import { forwardRef } from 'react';
import SanitizedHTML from 'react-sanitized-html';
import { usePlanCtx } from '../../../planDetailsContext';
import { SectionConatiner } from '../../ui-blocks/containers';
import { SectionHeading } from '../../ui-blocks/typograpghy';
import { ISection } from '../types';
import { FAQ } from './faq/index.component';
import styles from './styles.module.css';

export const FAQAnswer: React.FC<{ answer: React.ReactElement | string }> = ({
  answer,
}) => {
  return (
    <div className={styles.FAQ}>
      <SanitizedHTML html={answer} />
    </div>
  );
};

const FAQSection: React.FC<ISection> = forwardRef(
  ({ id, name }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const planDetails = usePlanCtx();
    const { faq: FAQS } = planDetails;
    return (
      <div id={id} ref={ref}>
        {FAQS.length ? (
          <SectionConatiner border={false}>
            <SectionHeading>{name}</SectionHeading>
            {FAQS.map((faq, idx) => {
              return (
                <FAQ
                  key={idx}
                  question={faq.question}
                  answer={<FAQAnswer answer={faq.answer} />}
                ></FAQ>
              );
            })}
          </SectionConatiner>
        ) : null}
      </div>
    );
  }
);

export { FAQSection };
